import { observable, action } from 'mobx';
import * as services from '../services/production';
import { isDataExist } from 'utils/dataTools';
import { message, Modal } from 'antd';
import { omit,isEmpty } from 'lodash'
class Workorder {
  @observable isLoading = false;
  /* 列表 */
  @observable workSelectKeys = [];
  @observable workList = []
  @observable workPage = {pageIndex:1,pageSize:10}
  @observable deviceByList = []

  /* 弹窗 */
  @observable visible = false
  @observable status = ''
  @observable currentWork = {}
  @observable editInfo = {}

  @observable materialId = ''
  @observable deviceId = ''
  @observable procedureId = ''

  @observable formData = []
  @observable list = []


  /* 查询列表 */
  @action async getList(params){
    this.isLoading = true;
		try {
      this.isLoading = false;
        this.list= [
          {
              
              workNo : '20190102001',
              type : '点检',
              number: '2020001',
              time : '20min',
              person : '刘肖',
              processTime : '2020-01-01 19:20:10'
          }
        ]
     
		} catch (error) {
			console.log(error);
		}
  }


	@action changeVisible = (visible)=>{
		this.visible = visible;
  }
  @action clearModal(){
		this.status = '';
    this.visible = false;
    this.workerId = '';
    this.currentWork = {}
  }
  @action clearData(){
    this.isLoading = false;
    /* 筛选条件 */
    this.plan_orderList = [];
    this.plan_bomList = [];
    this.reportBomId = '';
    this.reportDevId = '';
    this.reportWorkId = '';
    this.workStatus = '';
    this.report_deviceList = [];
    this.proceduresList = [];
    this.planByOrder = {};
    /* 列表 */
    this.workSelectKeys = [];
    this.workList = []
    this.workPage = {pageIndex:1,pageSize:10}
    this.deviceByList = []
  
    /* 弹窗 */
    this.visible = false
    this.status = ''
    this.currentWork = {}
    this.editInfo = {}
  
    this.materialId = ''
    this.deviceId = ''
    this.procedureId = ''
  }
}

let WorkorderStore = new Workorder();
export default WorkorderStore;
